export default __webpack_public_path__ + "static/media/exclusive-access.5c83d151.svg";